
import { createSelector, MemoizedSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';

import {
  EntityComercializacionesState,
  entityComercializacionesAdapter
} from './comercializaciones.state';
import { selectActividadFromCurrentEmpresaByTipoActividad } from '../entity-actividades/entity-actividades.selectors';

const { selectEntities, selectAll } = entityComercializacionesAdapter.getSelectors();

export const getError = (state: EntityComercializacionesState): any => state.error;

export const getIsLoading = (state: EntityComercializacionesState): boolean =>
  state.isLoading;

export const selectComercializacionesState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.comercializaciones
);

export const selectAllComercializaciones = createSelector(
  selectComercializacionesState,
  selectAll
);
export const selectEntitiesComercializaciones = createSelector(
  selectComercializacionesState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectComercializacionesError = createSelector(
  selectComercializacionesState,
  getError
);

// MemoizedSelector<object,any>
export const selectComercializacionesIsLoading = createSelector(
  selectComercializacionesState,
  getIsLoading
);

export const selectAllComercializacionesFromCurrentEmpresa = createSelector(
  selectAllComercializaciones,
  selectActividadFromCurrentEmpresaByTipoActividad(2),
  (comercializaciones, actividad) =>
  comercializaciones.filter((c) => c.actividad_id == actividad.id)
);
